// init base functions
    $(window).on('load', function () {
        classOnBody($('main').attr('id'));
        scrollDirection();
        initGettersAndSetters();
        changeTouchClickText();
    });
    $(window).on('hashchange', function () {
        initGettersAndSetters();
    });

// general input masks
    if (is.not.ie()) {
        $('.cepMask').mask("99999-999");
        $('.cpfMask').mask("999.999.999-99");
        $('.dataMask').mask("99/99/9999");
        $('.foneMask').focusout(function () {
            var phone, element;
            element = $(this);
            element.unmask();
            phone = element.val().replace(/\D/g, '');
            if (phone.length > 10) {
                element.mask("(99) 99999-999?9");
            } else {
                element.mask("(99) 9999-9999?9");
            }
        }).trigger('focusout');
    }

// init AOS
    if (is.not.ie()) {
        AOS.init();
    } else {
        $('*').removeAttr("data-aos");
    }

// components
    if ($('.liSelect').length) {
        $('.liSelect select').on('focusin', function () {
            $(this).parent('.liSelect').addClass('is-active');
        });
        $('.liSelect select').on('focusout', function () {
            $(this).parent('.liSelect').removeClass('is-active');
        });
    }
    if ($('.c-widget--suspendedMenu').length) {
        $('.selectArch').on('click', function () {
            $(this).parent('.c-widget__content').children('ul').toggleClass('is-active');
        });

        $(".c-widget--suspendedMenu").on('mouseleave', function () {
            $(this).children('.c-widget__content').children('ul').removeClass('is-active');
        });
    }
    if ($('.c-widget--premios').length) {
        $(window).on('load', function () {
            var swiper__premios = new Swiper('.swiper__premios', {
                speed: 400,
                spaceBetween: 10,
                loop: true,
                navigation: {
                    nextEl: '.c-widget--premios .swiper-button-next',
                    prevEl: '.c-widget--premios .swiper-button-prev',
                },
            });
        });
    }
    if ($('.c-widget--lastNews').length) {
        limitCaracters($('.c-widget--lastNews ul h3'), 90);
    }
    if ($('.c-widget--instagram').length) {
        var userFeed = new Instafeed({
            get: 'user',
            userId: '516311351',
            accessToken: '516311351.2a46ab3.a2ebc8c9dba648fe81b8d7e0370fca9d',
            limit: 6,
            resolution: 'standard_resolution',
            template: '<li><a href="{{link}}" target="_blank" class="u-aspectRatio u-aspectRatio--1-1"><img src="{{image}}" alt="{{caption}}" class="instaImg"/></a></li>',
        });
        userFeed.run();
    }
    if ($('.c-postCard').length) {
        limitCaracters($('.c-postCard h2'), 130);
    }

// sections
    if ($('.s-agenda').length) {
        var swiper__agenda = new Swiper('.swiper__agenda', {
            speed: 400,
            spaceBetween: 10,
            navigation: {
                nextEl: '.s-agenda .swiper-button-next',
                prevEl: '.s-agenda .swiper-button-prev',
            },
        });

    }

// nav
    if ($('.l-nav').length) {
        // vars
        var nav_scrollInit = 0;
        var nav_classActive = 'is-active';

        function closeAllSubMenus() {
            $('.liWithOneLevelSubMenu').removeClass(nav_classActive);
            $('.main__moreCategories').removeClass(nav_classActive);
            $('.l-nav__responsiveContent').removeClass('is-active');
        }

        function showMask() {
            $('.l-nav__maskMenu').addClass(nav_classActive);
        }

        function hideMask() {
            $('.l-nav__maskMenu').removeClass(nav_classActive);
        }

        // scroll
        $(window).on('scroll', function (event) {
            var scrollBody = $(this).scrollTop();

            // scroll up to 99
            // if (scrollBody > 99) {
            //     $('.l-nav').addClass('scrolled');
            // } else {
            //     $('.l-nav').removeClass('scrolled');
            // }

            // middle class
            if (scrollBody > 600) {
                $('.l-nav').addClass('hidden');
                $('.l-nav').addClass('scrolledMiddle');
            } else {
                $('.l-nav').removeClass('hidden');
                $('.l-nav').removeClass('scrolledMiddle');
            }

            // scroll up or down
            if (scrollBody < nav_scrollInit) {
                $('.l-nav').removeClass('hidden');
                $('.l-nav').addClass('scrolledUp');
                $('.l-nav').removeClass('scrolledDown');
            } else {
                $('.l-nav').removeClass('scrolledUp');
                $('.l-nav').addClass('scrolledDown');
            }

            // close menus on hidden nav
            if ($('.l-nav').hasClass('hidden')) {
                closeAllSubMenus();
            }

            // reference var
            nav_scrollInit = scrollBody;
        });
        $(window).on('load', function (event) {
            var scrollBody = $(this).scrollTop();
            if (scrollBody > 1) {
                //$('.l-nav').addClass('scrolled');
            } else {
                //$('.l-nav').removeClass('scrolled');
            }
        });

        // sub menu's
       /* $(document).on('click', '.menu-item-has-children', function () {
            if (($(this).parent('.moreCategories__list').parent('.main__moreCategories').hasClass('is-active')) || ($('.l-nav__responsiveContent').hasClass('is-active'))) {
                showMask();
                $(this).toggleClass(nav_classActive);
            } else {
                if ($(this).hasClass(nav_classActive)) {
                    closeAllSubMenus();
                    hideMask();
                } else {
                    closeAllSubMenus();
                    showMask();
                    $(this).addClass(nav_classActive);
                }
            }
        });
        $('.moreCategories__head').on('click', function () {
            if ($('.main__moreCategories').hasClass(nav_classActive)) {
                $('.main__moreCategories').removeClass(nav_classActive);
                hideMask();
                closeAllSubMenus();
            } else {
                closeAllSubMenus();
                $('.main__moreCategories').addClass(nav_classActive);
                showMask();
            }
        });*/

        // mask menu
        $('.l-nav__maskMenu,.closeMenu').on('click', function () {
            closeAllSubMenus();
            hideMask();
        });

        // make adapt menu categories
        var w_categoriesList = $('.main__categories').width();
        var w_container = $('.main__secondary .u-containerFlex').width();
        var w_moreCategories = $('.main__moreCategories').width();

        function refreshWidths() {
            w_categoriesList = $('.main__categories').width();
            w_container = $('.main__secondary .u-containerFlex').width();
            w_moreCategories = $('.main__moreCategories').width();
            return w_categoriesList;
        }

        function resetMenu() {
            $('.main__categories > li').removeClass('showInSubMenu');
            $('.main__categories > li').removeClass('showInMainNav');
        }

        function removeMoreCategories() {
            var qtdLi = $('.main__moreCategories .moreCategories__list li').length;
            if (qtdLi == 0) {
                $('.main__moreCategories').addClass('u-dnone');
            }
        }

        function get__mainLiWidths() {
            var arrayWidths = [];
            var finalWidth = 0;
            $('.main__categories > li').each(function (index) {
                arrayWidths.push($(this).width() + 30);
                finalWidth = arrayWidths.reduce(function (anterior, atual) {
                    return anterior + atual;
                });
            });
            finalWidth = finalWidth - 10;
            return finalWidth;
        }

        function markLiWithClass() {
            $('.main__categories > li').first().addClass('js-firstLi');

            if (get__mainLiWidths() < w_categoriesList) {
                $('.main__categories > li').addClass('showInMainNav');
                $('.main__categories > li').removeClass('showInSubMenu');
                $('.main__moreCategories').addClass('u-dnone');
            } else {
                $('.main__moreCategories').removeClass('u-dnone');
                // calc the sizes and organize list items
                var newArrayWidths = [];
                var newFinalWidth;
                $('.main__categories > li').each(function () {
                    newArrayWidths.push($(this).width() + 35);
                    newFinalWidth = newArrayWidths.reduce(function (anterior, atual) {
                        return anterior + atual;
                    });
                    if (newFinalWidth <= $('.main__categories').width()) {
                        $(this).addClass('showInMainNav');
                    } else {
                        $(this).addClass('showInSubMenu');
                    }
                });
            }
        }

        function putLiInSubMenu() {
            $('.main__moreCategories .moreCategories__list').html('');
            $('.main__secondary .showInSubMenu').each(function (index) {
                var thisContent = '<li>' + $(this).html() + '</li>';
                $('.main__moreCategories .moreCategories__list').append(thisContent);
            });
        }

        function createSubMenuInMoreCategories() {
            $(".main__moreCategories li").each(function (index) {
                if ($(this).children('ul').length) {
                    $(this).addClass('liWithOneLevelSubMenu');
                }
            });

        }

        $(window).on('load resize', function () {
            refreshWidths();
            resetMenu();
            get__mainLiWidths();
            markLiWithClass();
            putLiInSubMenu();
            createSubMenuInMoreCategories();
            removeMoreCategories();
        });

        // toggle menu responsive
        $('.main__primary .c-hamburguer').on('click', function () {
            $('.l-nav__responsiveContent').addClass('is-active');
            showMask();
        });
    }

// modules
    if ($('.wppLink').length) {
        var number = 554830810047;

        // this var have an options, elements and others things of the module
        var wppl = {
            el: $('.wppLink'),
            icon: $('.wppLink__roundedIcon'),
            infos: $('.wppLink__infos'),
            form: $('.wppLink__form'),
            formBtn: $('#btnWhats'),
            close: $('.wppLink__close')
        };

        // this var have an options and parameters of the link
        var wppl__parts = {
            link_mobile: 'http://api.whatsapp.com/',
            link_web: 'https://web.whatsapp.com/',
            phone: 'send?phone=',
            msg: 'text='
        };

        // make the final link
        wppl.icon.on('click', function () {
            if (is.iphone() || is.androidPhone() || is.windowsPhone() || is.blackberry() || is.mobile()) {
                // MOBILE VERSION
                if (!wppl.el.hasClass('wppLink--withForm')) {
                    window.open(wppl__parts.link_mobile + wppl__parts.phone + number, '_blank');
                } else {
                    toggleForm();
                }
            } else {
                // WEB VERSION
                if (!wppl.el.hasClass('wppLink--withForm')) {
                    window.open(wppl__parts.link_web + wppl__parts.phone + number, '_blank');
                } else {
                    toggleForm();
                }
            }
        });
        wppl.formBtn.on('click', function (e) {
            var userName = $('#formWhats_nome').val();
            var userMsg = $('#formWhats_mensagem').val();
            userFullMsg = 'Olá, me chamo *' + userName + '* E tenho essa mensagem: *' + userMsg + '*';
            if (is.iphone() || is.androidPhone() || is.windowsPhone() || is.blackberry() || is.mobile()) {
                window.open(wppl__parts.link_mobile + wppl__parts.phone + number + '&' + wppl__parts.msg + userFullMsg, '_blank');
            } else {
                window.open(wppl__parts.link_web + wppl__parts.phone + number + '&' + wppl__parts.msg + userFullMsg, '_blank');
            }
        });

        function toggleForm() {
            wppl.form.toggleClass('is-active');
            wppl.form.removeClass('u-dnone');
        }

        wppl.close.on('click', function () {
            wppl.form.removeClass('is-active');
        });

        // check modifiers and remove useless elements
        if (wppl.el.hasClass('wppLink--hideNumber')) {
            $('.wppLink .wppNumber').remove();
        }
        if (wppl.el.hasClass('wppLink--hideCaption')) {
            $('.wppLink .wppCaption').remove();
        }
        if (wppl.el.hasClass('wppLink--onlyIcon')) {
            $('.wppLink .wppLink__infos').remove();
        }
        if (!wppl.el.hasClass('wppLink--withForm')) {
            $('.wppLink .wppLink__form').remove();
        }

        // check dispositive and remove useless elements
        if (is.mobile()) {
            // removeCaption
            $('.wppLink .wppCaption').remove();
            if (!wppl.el.hasClass('wppLink--hideNumber')) {
                wppl.el.addClass('wppLink--hideCaption');
            }

            if (wppl.el.hasClass('wppLink--disableFormInMobile')) {
                wppl.form.remove();
                wppl.el.removeClass('wppLink--withForm');
            }
        }
    }
    if ($('#w_ieDetect').length) {
        function showMessageOnIE(warnLevel) {
            // warnLevel = 1 -> Remover aviso
            // warnLevel = 2 -> Recolher aviso
            // warnLevel = 3 -> Bloquear navegação

            var ieDetectEl = $('#w_ieDetect');
            var ieDetectEl__mask = $('#w_ieDetect__mask');
            var ieDetectEl__unlock = $('.w_ieDetect__unlockSite');

            if (is.ie()) {
                console.log('IE DETECTED')
                if (warnLevel == 1) {
                    $('body').css('overflow', 'hidden');
                    ieDetectEl.removeClass('u-dnone').addClass('is-visible');
                    ieDetectEl__mask.removeClass('u-dnone').addClass('is-visible');

                    ieDetectEl__unlock.on('click', function () {
                        ieDetectEl.remove();
                        ieDetectEl__mask.remove();
                        $('body').css('overflow-y', 'auto');
                        $('body').css('overflow-x', 'hidden');
                    });
                }
                if (warnLevel == 2) {
                    //block overflow and show modal
                    $('body').css('overflow', 'hidden');
                    ieDetectEl.removeClass('u-dnone').addClass('is-visible');
                    ieDetectEl__mask.removeClass('u-dnone').addClass('is-visible');

                    // hide modal and mask
                    ieDetectEl__unlock.on('click', function () {
                        $(this).remove();
                        ieDetectEl__mask.remove();
                        ieDetectEl.removeClass('is-visible');
                        ieDetectEl.addClass('is-fixed');
                        $('body').css('overflow-y', 'auto');
                        $('body').css('overflow-x', 'hidden');
                    });
                }
                if (warnLevel == 3) {
                    $('nav').remove();
                    $('header').remove();
                    $('footer').remove();
                    $('main').remove();
                    ieDetectEl__unlock.remove();
                    $('body').css('overflow', 'hidden');
                    ieDetectEl.removeClass('u-dnone').addClass('is-visible');
                    ieDetectEl__mask.removeClass('u-dnone').addClass('is-visible');
                }
            } else {
                ieDetectEl.remove();
                ieDetectEl__mask.remove();
            }
        }

        $(window).on('load', showMessageOnIE(3));
    }
    if ($('.auxElements__grid').length) {
        $('.auxElements__controls .toggleGrid').on('click', function () {
            $('.auxElements__controls .toggleGrid').toggleClass('is-active');
            $('.auxElements__grid').toggleClass('u-dnone').toggleClass('is-active');
            $('.auxElements__grid .line').toggleClass('is-active');
        });
    }
    if ($('.auxElements__controls').length) {
        function identifyScroll() {
            returnScroll = 1;
            if ($('body').hasClass('scrolledDown')) {
                returnScroll = 'Down';
            } else if ($('body').hasClass('scrolledUp')) {
                returnScroll = 'Up';
            } else {
                returnScroll = 'Static';
            }
            return returnScroll;
        }

        function tasksAuxVars() {
            $('.auxElements__controls .scrollEfetuado').html(Math.round($(window).scrollTop()));
            $('.auxElements__controls .scrollDirection').html(identifyScroll());
            $('.auxElements__controls .viewportWidth').html(Math.round($(window).width()));
            $('.auxElements__controls .viewportHeight').html(Math.round($(window).height()));
            $('.auxElements__controls .navHeight').html(Math.round(get__navHeight()));
        }

        $(document).on('ready', function () {
            tasksAuxVars();
        });
        $(window).on('load', function () {
            tasksAuxVars();
        });
        $(window).on('resize', function () {
            tasksAuxVars();
        });
        $(window).on('scroll', function () {
            tasksAuxVars();
        });
    }
    if ($('.c-article').length) {
        var $all_oembed_videos = $("iframe[src*='youtube'], iframe[src*='vimeo'], iframe[src*='dailymotion']");
        $all_oembed_videos.each(function() {
            $(this).removeAttr('height').removeAttr('width').wrap( "<div class='embed-container'></div>" );
        });
    }
document.addEventListener("DOMContentLoaded", function(event) {
    document.querySelectorAll('img').forEach(function(img){
        img.onerror = function(){this.style.display='none';};
    })
});